import _sfc_main from "./component-library95.mjs";
import "./component-library96.mjs";
import normalizeComponent from "./component-library97.mjs";
var _sfc_render = function render() {
  var _a;
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _vm.isExternal === void 0 && _setup.tagComponent !== "a" || _vm.isExternal === false ? _c(_setup.tagComponent, _vm._b({ ref: "linkElement", tag: "component", class: _setup.classes, attrs: { "data-tealium-rel": _setup.dataTealium, "disabled": _vm.disabled, "type": _vm.type }, on: { "click": _setup.onClick } }, "component", _setup.linkProps, false), [_vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.label))];
  })], 2) : _c("a", { ref: "linkElement", class: _setup.classes, attrs: { "href": (_a = _setup.link) == null ? void 0 : _a.toString(), "target": _vm.sameWindow ? "_self" : "_blank", "data-tealium-rel": _setup.dataTealium } }, [_vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.label))];
  }), _vm.isExternal && !_vm.sameWindow ? _c("span", { staticClass: "sr-only" }, [_vm._v("(Wird in einem neuen Tab geöffnet)")]) : _vm._e()], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "563177ee",
  null,
  null
);
const LinkButton = __component__.exports;
export {
  LinkButton as default
};
